import { connect, MapStateToProps } from 'react-redux'
import { Props } from './DigitalGiveawayButton'
import { openDigitalGiveawayModal } from '../../redux/actions/app/digitalGiveaway.actions'
import configurationIsBuildableSelector from '../../redux/selectors/configuration/configurationIsBuildableSelector'

type StateProps = Pick<Props, 'configurationIsBuildable'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    configurationIsBuildable: configurationIsBuildableSelector(state),
})

type DispatchProps = Pick<Props, 'openDigitalGiveawayModal'>

const mapDispatchToProps: DispatchProps = {
    openDigitalGiveawayModal,
}

export default connect(mapStateToProps, mapDispatchToProps)
